import React from 'react'

import { IJob } from '../interfaces/IJob'
import { Heading } from './Heading'
import { LinkButton } from './LinkButton'

export const Job = ({ id, title, slug, excerpt }: IJob) => {
  return (
    <div className="grid justify-items-start gap-4 md:gap-8 p-6 md:p-8 bg-primary rounded text-white">
      <Heading as="h2" className='font-semibold text-secondary text-2xl lg:text-2xl'>{title}</Heading>

      <div className="" dangerouslySetInnerHTML={{ __html: excerpt! }} />

      <LinkButton className='button--secondary' href={`/volne-pozice/${slug}`}>Více informací</LinkButton>
    </div>
  )
}
